import React, { useEffect } from 'react';
import { Box } from '@material-ui/core/';
import { observer } from 'mobx-react';
import { useMediaQuery, useTheme } from '@material-ui/core';

import { useStores } from '../../hooks/use-stores';

import Filter from './Filter';
import OrdersTable from './OrdersTable';
import OrderCard from './OrderCard';

const OrderList = observer(() => {
    const theme = useTheme();
    const isSM = useMediaQuery(theme.breakpoints.down('sm'));
    const { ProfileOrderStore: store } = useStores();
    const { loaderOrders, getOrders, setOrdersToCurrent, setOrdersToArchive, ordersStatus, sortedOrders } = store || {};

    useEffect(() => {
        getOrders();
    }, [getOrders]);

    return (
        <>
            <Filter />
            <Box display="flex" justifyContent="space-between" m="auto" width={180} mb="24px">
                <span className={ordersStatus === 0 ? 'showLink showLink_active' : 'showLink'} onClick={setOrdersToCurrent}>
                    Текущие
                </span>
                <span className={ordersStatus === 1 ? 'showLink showLink_active' : 'showLink'} onClick={setOrdersToArchive}>
                    История
                </span>
            </Box>

            {isSM ? <OrderCard load={loaderOrders} data={sortedOrders} /> : <OrdersTable load={loaderOrders} data={sortedOrders} />}
        </>
    );
});

export default OrderList;
